import {
  createEmptyCard,
  // formatDate,
  // fsrs,
  // generatorParameters,
  Rating,
  // Grades,
  FSRS,
} from "ts-fsrs";

// Creating an empty card
function createCardFromDB(reviewed_card) {
  const emptyCard = createEmptyCard();

  // Updating the emptyCard with the reviewed_card data
  emptyCard.due = reviewed_card.due; // Date when the card is next due for review
  emptyCard.stability = reviewed_card.stability; // A measure of how well the information is retained
  emptyCard.difficulty = reviewed_card.difficulty; // Reflects the inherent difficulty of the card content
  emptyCard.elapsed_days = reviewed_card.elapsed_days; // Days since the card was last reviewed
  emptyCard.scheduled_days = reviewed_card.scheduled_days; // The interval of time in days between this review and the next one
  emptyCard.learning_steps = reviewed_card.learning_steps; // Keeps track of the current step during the (re)learning stages
  emptyCard.reps = reviewed_card.reps; // Total number of times the card has been reviewed
  emptyCard.lapses = reviewed_card.lapses; // Times the card was forgotten or remembered incorrectly
  emptyCard.state = reviewed_card.state; // The current state of the card (New, Learning, Review, Relearning)
  emptyCard.last_review = reviewed_card.last_review;

  return emptyCard;
}

// This function will handle the update for a successful card review
export function updateReviewedCard(reviewed_card, rating) {
  // Creating a "card" object
  const card = createCardFromDB(reviewed_card);

  const f = new FSRS();

  if (rating == 1) {
    let scheduling_cards = f.next(card, new Date(), Rating.Again);
    const current_card = scheduling_cards["card"];
    return current_card;
  } else {
    // On first correct answer, override FSRS and mark as known
    const repsBefore = typeof card.reps === "number" ? card.reps : 0;
    if (repsBefore === 0) {
      const now = new Date();
      const due = new Date(now);
      due.setDate(due.getDate() + 90);

      card.difficulty = 1;
      card.stability = 25;
      card.state = 3;
      card.scheduled_days = 90;
      card.due = due;
      card.last_review = now;
      card.reps = repsBefore + 1;

      return card;
    }

    const r =
      rating === 4 ? Rating.Easy : rating === 2 ? Rating.Hard : Rating.Good;
    let scheduling_cards = f.next(card, new Date(), r);
    const current_card = scheduling_cards["card"];
    return current_card;
  }
}
